import { TextGroupCombinedProps } from './types';

const usePresenter = (props: TextGroupCombinedProps): TextGroupCombinedProps => {
  return props;
};

export default usePresenter;
